export default "amazon.logo352d4e042476837f.svg"